// A won job's buildings and areas go into Field Service's register (the API's
// asset-register.ts), once its Accept has finished. Never part of the Accept
// itself: a failure here leaves the acceptance as it is, and the next Accept
// of the job carries on where this stopped (it is safe to run again).
import { registerJobApi } from './api';
import { takeServerChange } from './device-db';

/** Calls the register takes at most: each makes entries for up to ~25 s. */
const REGISTER_ROUNDS = 8;

/** Make the register for the accepted option's job; the device's buildings, areas and condition records take their links. */
export async function addToRegister(optionId: string): Promise<void> {
  for (let round = 0; round < REGISTER_ROUNDS; round++) {
    const answer = await registerJobApi(optionId);
    for (const change of answer.changes) await takeServerChange(change.id, change.fields, change.etag);
    if (answer.done) return;
  }
}
